module.exports = __webpack_public_path__ + "static/media/traffic-severe.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/regscoaches/traffic-severe.svg
// module id = 833
// module chunks = 0